import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '',
    component: () => import('../pages/HomePage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
